import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GuidelineExpanderCard from 'app/pages/loanApplication/components/GuidelineCitations/GuidelineExpanderCard';
import PropTypes from 'prop-types';

import useLoanId from 'hooks/useLoanId';

import {
  fetchGuidelineContentAction,
  sendMessageAction,
  setGuidelineFullViewAction,
} from 'store/aiChat/actions';
import { selectApplicationIdFromDeal } from 'store/loanApplications/selectors/deal.selectors';

import { buildCitationFromContentProps } from '../guideline.utils';

import { buildAskAboutGuidelinePrompt } from './GuidelineExpanderCardContent.utils';

const GuidelineExpanderCardContent = ({ contentProps }) => {
  const dispatch = useDispatch();
  const loanId = useLoanId();
  const applicationId = useSelector(selectApplicationIdFromDeal);

  const citation = buildCitationFromContentProps(contentProps);

  const onReadFullSection = useCallback(() => {
    dispatch(setGuidelineFullViewAction(citation));
    dispatch(
      fetchGuidelineContentAction({
        loanId,
        citationId: citation.id,
        sourceId: citation.sourceId,
        sectionNumber: citation.section,
      }),
    );
  }, [dispatch, loanId, citation]);

  const onAskAboutGuideline = useCallback(() => {
    dispatch(
      sendMessageAction({ loanId, applicationId, content: buildAskAboutGuidelinePrompt(citation) }),
    );
  }, [dispatch, loanId, applicationId, citation]);

  return (
    <GuidelineExpanderCard
      citation={citation}
      onAskAboutGuideline={onAskAboutGuideline}
      onReadFullSection={onReadFullSection}
    />
  );
};

GuidelineExpanderCardContent.propTypes = {
  contentProps: PropTypes.shape({
    citationId: PropTypes.string.isRequired,
    number: PropTypes.number,
    sourceId: PropTypes.string,
    sourceName: PropTypes.string,
    sourceShortName: PropTypes.string,
    sectionNumber: PropTypes.string,
    sectionTitle: PropTypes.string,
    excerpt: PropTypes.string,
  }).isRequired,
};

export default memo(GuidelineExpanderCardContent);
